import { render, staticRenderFns } from "./ModalImageViewer.vue?vue&type=template&id=6b65f11a&"
import script from "./ModalImageViewer.vue?vue&type=script&lang=js&"
export * from "./ModalImageViewer.vue?vue&type=script&lang=js&"
import style0 from "./ModalImageViewer.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports